export const faqs = [
    {
        question: "Is there a dedicated house sitting visa?",
        answer: "No, there is no specific house sitting visa for any country. House sitters typically travel on a standard tourist visa.",
    },
    {
        question: "Can I get a house sitting visa upon arrival at the airport?",
        answer: "No, a dedicated house sitting visa cannot be obtained upon arrival. You must apply for a tourist visa in advance according to the requirements of the country you're visiting.",
    },
    {
        question: "What documents do I need for house sitting abroad?",
        answer: "For house sitting, you will generally need a valid passport, proof of accommodation (which may be provided by your house sit arrangement), and sometimes proof of onward travel. Ensure all documents are in order before you travel.",
    },
    {
        question: "Can I work as a house sitter on a tourist visa?",
        answer: "Most tourist visas do not permit paid employment. However, house sitting is typically viewed as a non-remunerated arrangement and is generally allowed without a work visa, making it a viable option for travelers looking to experience new cultures.",
    },
    {
        question: "How do I find out the specific visa requirements for the country I'm house sitting in?",
        answer: "Visit the official government website or contact the embassy of the country you’re planning to house sit in for the most accurate and up-to-date visa requirements.",
    },
]